import CloseIcon from "@mui/icons-material/Close";
import {
  buttonClasses,
  Dialog as MuiDialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  styled
} from "@mui/material";
import React from "react";
import { HyroButton } from "@hyro-components";
import { BUTTON_VARIANTS, BUTTON_COLORS } from "@hyro-components/hyro-button/HyroButton.consts";

const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  paddingRight: theme.spacing(3),
  paddingLeft: theme.spacing(3),
  paddingBottom: theme.spacing(3),
  [`.${buttonClasses.startIcon}`]:{
    marginLeft: 0
  }
}));

const EMPTY_OBJ = {};

const Dialog = ({
  variant = "passive",
  open,
  title,
  children,
  disableSave,
  disableCancel,
  submitButtonProps = EMPTY_OBJ,
  submitButtonLoading = false,
  submitButtonText = "Confirm",
  cancelButtonText = "Cancel",
  cancelButtonLoading = false,
  additionalButton,
  handleCancel,
  handleSubmit,
  testId,
  handleClose,
  showCloseButton = false,
  confirmColor = "primary",
  ...props
}) => (
  <MuiDialog
    {...{
      fullWidth: true,
      open,
      ...props
    }}
    data-testid={testId}
  >
    <DialogTitle data-testid={`${testId}-dialog-title`}>{title}</DialogTitle>
    <DialogContent>{children}</DialogContent>
    {showCloseButton ? (
      <IconButton
        data-testid={`${testId}-close-icon`}
        onClick={handleClose}
        aria-label="close"
        sx={{ position: "absolute", right: 8, top: 8 }}
      >
        <CloseIcon />
      </IconButton>
    ) : null}
    {variant === "acknowledgement" || variant === "transactional" ? (
      <StyledDialogActions>
        {additionalButton ? additionalButton : null}
        {variant === "transactional" ? (
          <HyroButton
            disabled={disableCancel}
            loading={cancelButtonLoading}
            variant={BUTTON_VARIANTS.TEXT}
            color={BUTTON_COLORS.SECONDARY}
            onClick={handleCancel}
            data-testid={`${testId}-cancel-button`}
          >
            {cancelButtonText}
          </HyroButton>
        ) : null}
        <HyroButton
          {...{
            loading: submitButtonLoading,
            disabled: disableSave,
            color: BUTTON_COLORS.PRIMARY,
            variant: BUTTON_VARIANTS.CONTAINED,
            onClick: handleSubmit,
            ...submitButtonProps
          }}
          data-testid={`${testId}-submit-button`}
        >
          {submitButtonText}
        </HyroButton>
      </StyledDialogActions>
    ) : null}
  </MuiDialog>
);

export default Dialog;
